// TODO: should test this method
export function isDiff<T>(dataA?: T, dataB?: T, ignoreKeys?: string[]): boolean {
  // handle the basic checks
  if (
    typeof dataA !== typeof dataB ||
    (dataA == null && dataB != null) ||
    (dataA != null && dataB == null)
  ) {
    return true;
  }

  if (dataA == null && dataB == null) {
    return true;
  }

  // check the array cases
  if (Array.isArray(dataA)) {
    if (!Array.isArray(dataB)) {
      return true;
    }

    const foundDiff = dataA.some(function (valueA) {
      const foundArrDiff = dataB.some(function (valueB) {
        return isDiff(valueA, valueB, ignoreKeys);
      });

      return foundArrDiff;
    });

    return foundDiff;
  }

  // handle the object
  const foundDiff = Object.keys(dataA as object).some(function (key) {
    // check if we should ignore this key
    if (ignoreKeys != null) {
      const isIgnore = ignoreKeys.some((k) => k === key);
      if (isIgnore) {
        return false;
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const valueA = (dataA as any)[key];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const valueB = (dataB as any)[key];
    return valueA !== valueB;
  });

  return foundDiff;
}

export function uniqueStrArr(data?: string[]): string[] {
  const unique: string[] = [];
  if (data == null) {
    return unique;
  }

  for (let i = 0; i < data.length; i += 1) {
    const single = data[i];
    const found = unique.some((old) => old === single);
    if (found) {
      continue;
    }

    unique.push(single);
  }

  return unique;
}
